import React from "react";
import Lottie from "lottie-react";
import lottie404 from "../../Assets/Media/LottiesJSONs/error.json";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom"; // Import useNavigate

export default function NotFound() {
  const navigate = useNavigate(); // Get the navigate function
  const isMobile = useMediaQuery({
    query: "(max-width: 767px)",
  });

  return (
    <div className="pattern-bg2">
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",

          textAlign: "center",
        }}
        className="container a-padding a-container pattern-bg2"
      >
        <Lottie
          animationData={lottie404}
          loop
          autoplay
          style={{
            width: isMobile ? "200px" : "40%",
            background: "transparent",
          }}
          className=""
        />
        <div>
          <h1 className="!text-[20px] sm:!text-[16px] md:!text-[22px] lg:!text-[24px] xl:!text-[26px] p-4">
            Something went wrong!
          </h1>

          <button
            type="button"
            className="join-btn custom-btn main-button w-full text-center mb-2"
            onClick={() => navigate("/")} // Use navigate to go to the homepage
          >
            Go to Homepage
          </button>
        </div>
      </div>
    </div>
  );
}
